import React, { Component } from 'react';
import { reduxForm, Field } from 'redux-form';
import withNotify from '../../common/withNotify';
import withLoader from '../../common/withLoader';
import withGoBack from '../../common/withGoBack';
import withOnline from '../../common/withOnline';
import withTableName from '../../common/withTableName';
import Header from '../../components/Header';
import {
  renderField,
  requiredXray
} from '../../helpers/form-validations';
import { onGoBack } from '../../common/globals';
import { uploadXray } from '../../utils/utils';
import {
  getTableCaseByCaseId,
  updateTableWiseCaseByCaseId
} from '../../utils/db';
import Bugsnag from '../../helpers/bugsnag';
// import SelectFileOrTakePhoto from '../../components/Models/SelectFileOrTakePhoto';
import CaseChangesNoLonger from '../../components/Models/CasesChangesNoLonger';

class XrayUpload extends Component {
  constructor(props) {
    super(props);
    this.state = {
      OriginalFile: ''
    };
    // this.selectFileOrTakePhoto = null;
    // this.takePhotoModal = null;
    this.caseChangesNoLonger = null;
  }

  componentDidMount() {
    try {
      // this.selectFileOrTakePhoto =
      // new window.bootstrap.Modal(window.$('#selectFileOrTakePhoto'));
      // this.takePhotoModal =
      // new window.bootstrap.Modal(window.$('#takePhotoModal'));
      this.caseChangesNoLonger = new window.bootstrap.Modal(window.$('#CaseChangesNoLongerModal'));
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onSubmit = async (formData) => {
    try {
      const {
        setLoader, notify, online, params: { id }, tableName, goBack
      } = this.props;
      const caseDetailsRes = await getTableCaseByCaseId(id, tableName);
      if (caseDetailsRes && caseDetailsRes.DGR === '1') {
        this.caseChangesNoLonger.show();
        return;
      }
      const { OriginalFile } = this.state;
      formData.OriginalFile = OriginalFile;
      formData.CaseScheduleID = caseDetailsRes.CaseScheduleID;
      formData.Name = (formData.Name === null || formData.Name === undefined) ? '' : formData.Name.toUpperCase();

      setLoader(true);
      if (online) {
        uploadXray(formData).then(async (responseJson) => {
          setLoader(false);
          const {
            status, message, data, result
          } = responseJson;
          if (status) {
            if (result === 'success') {
              //  notify({ type: 'success', message });
              // Update into local db
              caseDetailsRes.case_xrays.push(data);
              await updateTableWiseCaseByCaseId(
                caseDetailsRes.RepCaseNo, caseDetailsRes, tableName
              );
              onGoBack(goBack);
            } else if (formData.OriginalFile === '' || formData.OriginalFile === undefined) {
              notify({ type: 'error', message: 'You must select a file to upload!', time: 2 });
            } else {
              notify({ type: 'error', message, time: 2 });
            }
          } else {
            notify({ type: 'error', message });
          }
        });
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  /* _onSelectImage = (imageData) => {
    try {
      window.document.getElementById('fileControl').files = imageData.files;
      this.setState({ OriginalFile: imageData.files[0] });
      this.selectFileOrTakePhoto.hide();
    } catch (e) {
      Bugsnag.notify(e);
    }
  }; */

  _onSelectImage = (imageData) => {
    try {
      this.setState({ OriginalFile: imageData.files[0] });
    } catch (e) {
      Bugsnag.notify(e);
    }
  };

  _onTakePhoto = (imageData) => {
    this.takePhotoModal.hide();
    this.selectFileOrTakePhoto.hide();
    const list = new DataTransfer();
    const file = new File(['content'], imageData.name);
    list.items.add(file);
    const myFileList = list.files;
    window.document.getElementById('fileControl').files = myFileList;
    try {
      this.setState({ OriginalFile: imageData });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  render() {
    const { goBack, handleSubmit, params: { id } } = this.props;
    return (
      <section className="xrays-section">
        <form onSubmit={handleSubmit(this._onSubmit)} form="XrayUploadForm">
          <Header
            actionButton={{ title: 'Upload' }}
            title="X-rays"
            goBack={() => onGoBack(goBack)}
          />
          <section className="xrays-section">
            <div className="container">
              <div className="xrays-block">
                <div className="row">
                  <div className="col-12 mb-4">
                    <Field
                      type="text"
                      name="Name"
                      className="form-control text-uppercase search-input-focus search-input"
                      placeholder="X-ray Name"
                      component={renderField}
                      validate={[requiredXray]}
                      onKeyDown={(evt) => ['?', '<', '>', '*', ':', '/', '\\', '"', '|'].includes(evt.key) && evt.preventDefault()}
                    />
                  </div>
                  <div className="col-12">
                    <input
                      type="file"
                      accept="image/*,.pdf,.dcm"
                      className="form-control x-ray-name x-ray-choose-file"
                      id="fileControl"
                      onChange={(e) => this._onSelectImage(e.target)}
                    />
                  </div>
                </div>
              </div>
            </div>
          </section>
        </form>
        {/* <SelectFileOrTakePhoto
          onSelectImage={this._onSelectImage} onTakePhoto={this._onTakePhoto}
        /> */}
        <CaseChangesNoLonger
          id={id}
        />
      </section>
    );
  }
}

const withForm = reduxForm({
  form: 'XrayUploadForm',
});

export default withTableName(
  withOnline(
    withGoBack(
      withForm(
        withNotify(
          withLoader(
            XrayUpload
          )
        )
      )
    )
  )
);
